import { AxiosPromise } from 'axios';
import qs from 'qs';
import { ApiPaginatedResponse, request } from "../../api";
import { ApiProfile } from "../../api/auth";

export interface ApiCoach {
    id: number,
    avatar?: string,
    first_name: string,
    affix?: string,
    last_name: string,
    email_address: string,
}

const rest = {
    getByPermalink: (permalink: string): AxiosPromise<{data: ApiProfile}> => {
        return request.get(`profiles/${permalink}`);
    },
    list: (query: { [key: string]: any }): AxiosPromise<ApiPaginatedResponse<ApiProfile[]>> => {
        return request.get(`profiles?${qs.stringify(query)}`);
    },
    listNew: (query?: { [key: string]: any }): AxiosPromise<ApiPaginatedResponse<ApiProfile[]>> => {
        return request.get(`profiles?${qs.stringify({ new: 1, ...query })}`);
    }
}

export default rest;
